module.exports = __webpack_public_path__ + "static/media/remove-education.45c0f40c.png";